import Member from "./Member";

export default Member;
